module.exports = __webpack_public_path__ + "images/new-ivp-banner.1ffe51d9.webp";